export const ACL_PAGE_PERMISSIONS = {
  PAGE_MANAGERS: 'page.managers',
  PAGE_GUESTS: 'page.guests',
  PAGE_OWNERS: 'page.owners',
  PAGE_VENDORS: 'page.vendors',
  PAGE_LOCATIONS: 'page.locations',
  PAGE_DEPARTMENTS: 'page.departments',
  PAGE_INCOME: 'page.income',
  PAGE_DASHBOARD: 'page.dashboard',
  PAGE_BOOKINGS: 'page.bookings',
  PAGE_BOOKING_CALENDAR: 'page.booking_calendar',
  PAGE_PAYMENTS: 'page.payments',
  PAGE_INVOICES: 'page.invoices',
  PAGE_PROFILE: 'page.profile',
  PAGE_BANK_ACCOUNTS: 'page.bank_accounts',
  PAGE_LOGIN: 'page.login',
  PAGE_SIGNUP: 'page.signup',
  PAGE_PROPERTY_OWNERS: 'page.property_owners',
  PAGE_PROPERTY_VENDORS: 'page.property_vendors',
  PAGE_NOTIFICATIONS: 'page.notifications',
  PAGE_VENDOR_PROPERTIES: 'page.vendor_properties',
  PAGE_EMAIL_TEMPLATES: 'page.email_templates',
  PAGE_SMS_TEMPLATES: 'page.sms_templates',
  PAGE_FEATURE_FLAGS: 'page.feature_flags',
};
